import React, { useState, useRef } from 'react';
import { IconFont } from '@src/features/common';
import Quill from 'quill';

type Props = ISFCLinkProps;
export interface ISFCLinkProps {
  quill?: Quill;
  hideToolbar: () => void;
}

export function SFCLink(props: Props) {
  const [linkDiaVisiable, setLinkDiaVisiable] = useState(false);
  const [linkTop, setLinkTop] = useState(0);
  const [linkVal, setLinkVal] = useState('');
  const inputEL = useRef<HTMLInputElement>(null);

  const linkChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = event.target.value;

    setLinkVal(val);
  };

  const hideLinkDia = () => {
    setLinkVal('');
    setLinkDiaVisiable(false);

    document.removeEventListener('click', hideLinkDia);
  };

  const showLinkDia = () => {
    const { quill } = props;
    const range = quill ? quill.getSelection() : null;
    const selectedTarget = range && quill ? quill.getBounds(range.index, range.length) : null;

    if (selectedTarget) {
      setLinkTop(selectedTarget.height + 54);
      setLinkDiaVisiable(true);
      document.addEventListener('click', hideLinkDia);

      props.hideToolbar();

      setTimeout(() => {
        inputEL && inputEL.current && inputEL.current.focus();
      });
    }
  };

  const setLink = () => {
    const quill = props.quill;

    if (quill && linkVal) {
      quill.format('link', linkVal, 'user');
      hideLinkDia();
    }
  };

  const triggerSetLink = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode === 13) {
      setTimeout(() => {
        setLink();
      });
    }
  };

  const stopPop = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.nativeEvent.stopImmediatePropagation();
  };

  return (
    <>
      <button className="button-item" onClick={showLinkDia}>
        <IconFont type="icon-e-link" />
        <span className="button-item__tip">链接</span>
      </button>
      <section
        className={'tool-bar__link-con'}
        style={{ top: linkTop + 'px', visibility: linkDiaVisiable ? 'visible' : 'hidden' }}
        onClick={stopPop}
      >
        <IconFont type="icon-e-link-pre" className="tool-bar__link-con__icon" />
        <input
          value={linkVal}
          onChange={linkChange}
          onKeyDown={triggerSetLink}
          ref={inputEL}
          type="text"
          className="tool-bar__link-con__input"
        />
        <IconFont type="icon-sure" className="tool-bar__link-con__button" onClick={setLink} />
      </section>
    </>
  );
}

export default SFCLink;
